import classNames from 'classnames'

import Textarea from './Textarea'
import ErrorLabel from './ErrorLabel'
import styles from './InputWithLabel.module.scss'

function InputWithLabel({
  label,
  value,
  id,
  onChange,
  required,
  placeholder,
  type,
  name,
  elementType,
  rows,
  maxLength,
  hasError,
  errorText,
}) {
  const getInputType = () => {
    switch (elementType) {
      case 'input':
        return (
          <>
            <label className={styles.label}>{label}</label>
            <Input
              type={type}
              id={id}
              name={name}
              className={classNames(styles.input)}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={onChange}
              errorText={errorText}
              hasError={hasError}
            />
          </>
        )

      case 'textarea':
        return (
          <>
            <label className={styles.label}>{label}</label>
            <Textarea
              type={type}
              id={id}
              name={name}
              className={classNames(styles.input)}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={onChange}
              rows={rows}
              maxLength={maxLength}
              hasError={hasError}
              errorText={errorText}
            />
          </>
        )

      case 'checkbox':
        return (
          <>
            <input
              type={type}
              id={id}
              name={id}
              className={classNames(styles.input)}
              placeholder={placeholder}
              required={required}
              checked={value}
              onChange={(e) => {
                onChange(e, type)
              }}
            />
            <label htmlFor={id} className={styles.checkboxLabel}>
              {label}
            </label>
          </>
        )
      default:
        return (
          <>
            <label className={styles.label}>{label}</label>
            <Input
              type={type}
              id={id}
              name={name}
              className={classNames(styles.input)}
              placeholder={placeholder}
              required={required}
              value={value}
              onChange={onChange}
              errorText={errorText}
              hasError={hasError}
            />
          </>
        )
    }
  }

  return (
    <div
      className={classNames(styles.inputLabelContainer, {
        [styles.checkboxContainer]: 'checkbox' === elementType,
      })}
    >
      {getInputType()}
    </div>
  )
}

export const Input = ({
  value,
  id,
  onChange,
  placeholder,
  type,
  name,
  hasError,
  errorText,
}) => (
  <div className={styles.inputContainer}>
    <input
      type={type}
      id={id}
      name={name}
      className={classNames(styles.input, { [styles.errorState]: hasError })}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e, id)}
    />
    {hasError && <ErrorLabel errorText={errorText} />}
  </div>
)

export default InputWithLabel
